import { apiClient, type PageEntity, type ItemUnitEntity } from '@/libs/api'
import { type ItemUnitsListRequestQuery } from '@/libs/api/types'

export type FetchItemUnitsListQuery = {
  tenantKey: string
  query?: ItemUnitsListRequestQuery
}

export type FetchItemUnitsListResponse = {
  data: ItemUnitEntity[]
  pagination: PageEntity | null
}

// 単位マスタ管理画面用一覧取得API（#4209: ADMIN は全拠点表示）
export const fetchItemUnitsList = async (
  { tenantKey, query }: FetchItemUnitsListQuery,
  signal?: AbortSignal
): Promise<FetchItemUnitsListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .item_units.list.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
